/**
 * Уніфіковані константи типографії для проєкту
 */

/**
 * Стабільний системний шрифт для критичних місць (описи, важливий текст)
 * Використовується для забезпечення стабільного відображення тексту на різних платформах
 */
export const SYSTEM_FONT_STABLE = '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif';

/**
 * Стиль для описів будинків та інших важливих текстів
 */
export const DESCRIPTION_TEXT_STYLE = {
  fontFamily: SYSTEM_FONT_STABLE,
  fontSize: '14px',
  fontWeight: 400,
  lineHeight: '20px',
  letterSpacing: '0px',
} as const;
